import { createContext } from 'react';
import { DateRange } from 'assets/js/pages/reports/types';
import { RelativeDateRangeOperator } from 'components/filter/types';
import { DateTime } from 'luxon';
import { ColumnSchema, ColumnSortDirection, GraphType } from 'types/domain';

interface IReportContext {
    dateRange: DateRange;
    setDateRange: (value: DateRange) => void;
    dateRangeType: RelativeDateRangeOperator;
    setDateRangeType: (value: RelativeDateRangeOperator) => void;
    chartColumn?: ColumnSchema;
    setChartColumn: (value?: ColumnSchema) => void;
    chartType?: GraphType;
    setChartType: (type?: GraphType) => void;
    sortColumn?: ColumnSchema;
    setSortColumn: (value?: ColumnSchema) => void;
    sortDirection?: ColumnSortDirection;
    setSortDirection: (value?: ColumnSortDirection) => void;
}

const ReportContext = createContext<IReportContext>({
    dateRangeType: 'YTD',
    dateRange: [DateTime.now(), DateTime.now()],
    setDateRange: () => {},
    setDateRangeType: () => {},
    setChartColumn: () => {},
    setChartType: () => {},
    setSortColumn: () => {},
    setSortDirection: () => {},
});

export { ReportContext };
export type { IReportContext };
